module.exports = __webpack_public_path__ + "img/video-call-grey.c8a0ff2a.svg";